jQuery(document).ready(function(){
  $j = jQuery;
  jQuery('.iso_standard').on('click',function(){
      jQuery(this).hide();
      jQuery('.en_standard').show();
	  //clear other standard fields and hide
      jQuery('.ft_height,.in_height,.in_height_unit,.lb_weight').val('').hide();
      jQuery('.ft_height_unit,.in_height_unit,.lb_weight_unit').hide();
      //show own standard fields
	  jQuery('input.cm_height').css('display','inline-block');
      jQuery('.cm_units,input.kg_weight,.kg_weight_unit').show();
      jQuery('.step1-measure').removeClass('ios_standard_metric');
      jQuery('.step1-measure').addClass('en_standard_metric');
  });
  jQuery('.en_standard').on('click',function(){
      jQuery(this).hide();
      jQuery('.iso_standard').show();
      //clear other standard fields and hide
      jQuery('input.cm_height').val('').hide();
      jQuery('.cm_units').hide();
      jQuery('input.kg_weight').val('').hide();
      jQuery('.kg_weight_unit').hide();
      //show own standard fields
      jQuery('.ft_height,.ft_height_unit,.in_height,.in_height_unit,.lb_weight,.lb_weight_unit').css('display','inline-block');
      jQuery('.step1-measure').addClass('ios_standard_metric');
      jQuery('.step1-measure').removeClass('en_standard_metric');
  });
  
  jQuery('.next.measurestep2').on('click', function(){
    //check for required fields fillups
    var en_standard, error = 0;
    if($j('span.en_standard').is(':visible')){
   	  en_standard = 1;
      if(jQuery('.num.cm_height').val()=='' || jQuery('.num.kg_weight').val()==''){
        jQuery('.num.cm_height').val()==''?jQuery('.num.cm_height').css('border-color','red'):'';
        jQuery('.num.kg_weight').val()==''?jQuery('.num.kg_weight').css('border-color','red'):'';
      	error = 1;
      }
    }else{
    	if(jQuery('.num.ft_height').val()=='' || jQuery('.num.lb_weight').val()==''){
          jQuery('.num.ft_height').val()==''?jQuery('.num.ft_height').css('border-color','red'):'';
          jQuery('.num.lb_weight').val()==''?jQuery('.num.lb_weight').css('border-color','red'):'';
          error = 1;
        }
    }
    
    if(error==0){
      //remove previous error
      jQuery('.num.cm_height, .num.kg_weight, .num.ft_height, .num.lb_weight').css('border-color','rgba(129,129,129,.25)');
	  $j('.error-msg-1').html('');
      //pass values to step2
      var height, weight = '';
      var name = $j('.text.profile_name').val()==''?'?':$j('.text.profile_name').val();
      var age = $j('.num.age').val()==''?'?':$j('.num.age').val();
      if(en_standard==1){
        height = $j('.num.cm_height').val()+'<span>cm</span>';
        weight = $j('.num.kg_weight').val()+'<span>kg</span>';
      }else{
        height = $j('.num.ft_height').val()+'<span>ft </span>'+$j('.num.in_height').val()+'<span>in</span>';
        weight = $j('.num.lb_weight').val()+'<span>lb</span>';
      }
      $j('.profile-val-name').html(name);
      $j('.profile-val-height').html(height);
      $j('.profile-val-weight').html(weight);
      $j('.profile-val-age').html(age);

      jQuery('.step1-measure').hide("slide", { direction: "left" }, 800);
      jQuery('.step2-measure').show("slide", { direction: "right" }, 800);
    }else{
    	$j('.error-msg-1').html('Invalid Height or Weight');
    }
  });
  $j('.editheightweight').on('click', function(){
	$j('.step2-measure').hide("slide", { direction: "right" }, 800);
	$j('.step1-measure').show("slide", { direction: "left" }, 800);
  });
  	
  	$j('span.confirmmeasure').on('click',function(){
      var error_measure2 = 0;
      $j(".measure-2-table .individual-attr-val input[type='text']").each(function(){
        if($j(this).val() == ''){
		  $j(this).css('border-color','red');
          error_measure2 = 1
        }
      });
      if(error_measure2==0){
        $j(".measure-2-table .individual-attr-val input[type='text']").each(function(){
          //remove errors
          $j(this).css('border-color','rgba(129,129,129,.25)');
        });
        $j('.error-msg-1,.error-msg-2').html('');
        //set global measure value set = true & close the form opening
		$j('button.addmeasurement').html('<i class="fa fa-check-circle"></i> Edit measurement');
		$j('button.addmeasurement').data('validation',1);
        addMeasurement();
      }else{
      	//show error message
        $j('.error-msg-2').html('<i>Please fill all measure values</i>');
        //set global measure value as incomplete
        $j('button.addmeasurement').html('Add measurements');
		$j('button.addmeasurement').data('validation',0);
      }
	});
  
   $j(".measure-2-table input[type='text']").on("keypress keyup blur",function (event) {
      //this.value = this.value.replace(/[^0-9\.]/g,'');
       $j(this).val($j(this).val().replace(/[^0-9\.]/g,''));
       if ((event.which != 46 || $j(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
         event.preventDefault();
       }
   });
  
  //before checkout form submit check for measurement
   $j('form.shopify-cart-form').on('submit', checkbeforesubmit);
  
   //check for saved customer data
  if($j('span.saved-measure-data').length && $j('span.saved-measure-data').html()!=''){
  	//the customer has saved data
    var customerdata = $j('span.saved-measure-data').html();
    var measuredata = customerdata.split('||');
    $.each(measuredata,function(i){
      if($j.trim(measuredata[i])!=''){
        var attr = measuredata[i].split('|');
	    var key = $j.trim(attr[0]).replace(/ /g,'_').toLowerCase();
        var val = $j.trim(attr[1]);
        fillsavedvalues(key,val);
        console.log(key+'--'+val);
       }
    });
  }
  //check if customer data is all filled initially and allow checkout
  checkinitiallyifmeasurefilled();
});

function fillsavedvalues(key,val){
	switch(key) {
      case 'measurement_for':
        $j('input[name="attributes[Measurement for]"]').val(val);
        break;
      case 'height_in_cm':
        $j('input[name="attributes[height in cm]"]').val(val);
        break;
      case 'height_ft':
        //if height in ft is available
        $j('span.en_standard').trigger('click');
        $j('select[name="attributes[height ft]"]').val(val);
        break;
      case 'height_inch':
        $j('select[name="attributes[height inch]"]').val(val);
        break;
      case 'weight_in_kg':
        $j('input[name="attributes[weight in kg]"]').val(val);
        break;
      case 'weight_in_lb':
        $j('input[name="attributes[weight in lb]"]').val(val);
        break;
      case 'age':
        $j('input[name="attributes[age]"]').val(val);
        break;
      case 'sleeves_length':
        $j('input[name="attributes[Sleeves length]"]').val(val);
        break;
      case 'shoulder_width':
        $j('input[name="attributes[Shoulder width]"]').val(val);
        break;
      case 'chest_around':
        $j('input[name="attributes[Chest around]"]').val(val);
        break;
      case 'stomach':
        $j('input[name="attributes[Stomach]"]').val(val);
        break;
      case 'hips':
        $j('input[name="attributes[Hips]"]').val(val);
        break;
      case 'neck':
        $j('input[name="attributes[Neck]"]').val(val);
        break;
      case 'torso_length':
        $j('input[name="attributes[Torso length]"]').val(val);
        break;
      case 'bicept_around':
        $j('input[name="attributes[Bicept around]"]').val(val);
        break;
      case 'wrist':
        $j('input[name="attributes[Wrist]"]').val(val);
        break;
      case 'rise':
        $j('input[name="attributes[Rise]"]').val(val);
        break;
      case 'paints_length':
        $j('input[name="attributes[Paints length]"]').val(val);
        break;
      case 'paints_waist':
        $j('input[name="attributes[Paints waist]"]').val(val);
        break;
      case 'thigh':
        $j('input[name="attributes[Thigh]"]').val(val);
        break;
     default:
     // code to be executed if n is different from case 1 and 2
    }  
}

function checkinitiallyifmeasurefilled(){
  //validate first step
  var errorinstep1 = 1;
  if(jQuery('.cm_height').val() != '' && jQuery('.kg_weight').val() != '' || jQuery('.ft_height').val() && jQuery('.lb_weight').val()){
  	//console.log('passed first step');
    errorinstep1 = 0;
  }
   var errorinstep2 = 0;
  jQuery('.individual-attr-val input').each(function(){
      if(jQuery(this).val() == ''){
          errorinstep2 = 1;
      }
  });
  //if no error in step1 and step2
  if(errorinstep1==0 && errorinstep2==0){
  	$j('button.addmeasurement').html('<i class="fa fa-check-circle"></i> Edit measurement');
	$j('button.addmeasurement').data('validation',1);
  }
}

function checkbeforesubmit(){
  if(!$('button.addmeasurement').data('validation')){
  	$j('.measure-incomplete-notice').html('<i class="fa fa-cross"></i> Please complete measurement');
    return false;
  }
}

function addMeasurement(){
  $j = jQuery;
  $j('.shopify-cart-form').toggleClass('addmeasureactive');
  $j('.measureform').slideToggle();
  $j('.measure-incomplete-notice').html('');
  	return false;
  }